import React from 'react';
import { 
  ExclamationTriangleIcon, 
  CheckCircleIcon, 
  XCircleIcon,
  TrashIcon 
} from '@heroicons/react/24/outline';

const ConfirmActionModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  action, 
  userName, 
  isLoading = false 
}) => {
  if (!isOpen) return null;

  const getActionConfig = () => {
    switch (action) {
      case 'activate':
        return {
          title: 'Активировать пользователя',
          message: `Вы уверены, что хотите активировать пользователя "${userName}"?`,
          icon: CheckCircleIcon,
          iconColor: 'text-green-500',
          bgColor: 'bg-green-50',
          buttonColor: 'bg-green-600 hover:bg-green-700',
          buttonText: 'Активировать'
        };
      case 'deactivate':
        return {
          title: 'Деактивировать пользователя',
          message: `Вы уверены, что хотите деактивировать пользователя "${userName}"?`,
          icon: XCircleIcon,
          iconColor: 'text-orange-500',
          bgColor: 'bg-orange-50',
          buttonColor: 'bg-orange-600 hover:bg-orange-700',
          buttonText: 'Деактивировать'
        };
      case 'delete':
        return {
          title: 'Удалить пользователя',
          message: `Вы уверены, что хотите навсегда удалить пользователя "${userName}"? Это действие нельзя отменить.`,
          icon: TrashIcon,
          iconColor: 'text-red-500',
          bgColor: 'bg-red-50',
          buttonColor: 'bg-red-600 hover:bg-red-700',
          buttonText: 'Удалить навсегда'
        };
      default:
        return {
          title: 'Подтвердить действие',
          message: `Вы уверены, что хотите выполнить это действие для пользователя "${userName}"?`,
          icon: ExclamationTriangleIcon,
          iconColor: 'text-yellow-500',
          bgColor: 'bg-yellow-50',
          buttonColor: 'bg-blue-600 hover:bg-blue-700',
          buttonText: 'Подтвердить'
        };
    }
  };

  const config = getActionConfig();
  const IconComponent = config.icon;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div 
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          onClick={onClose}
        ></div>

        {/* Modal panel */}
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className={`${config.bgColor} px-4 pt-5 pb-4 sm:p-6 sm:pb-4`}>
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-white sm:mx-0 sm:h-10 sm:w-10">
                <IconComponent className={`h-6 w-6 ${config.iconColor}`} />
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                  {config.title}
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    {config.message}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              className={`w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm ${config.buttonColor} ${
                isLoading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="flex items-center">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  {config.buttonText}...
                </div>
              ) : (
                config.buttonText
              )}
            </button>
            <button
              type="button"
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              onClick={onClose}
              disabled={isLoading}
            >
              Отмена
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmActionModal; 